<template>
  <v-sheet class="py-10">
    <v-row class="listitem flex-wrap justify-center" lines="three">
      <v-col v-for="(item, i) in items" :key="i" cols="12" md="6" lg="4">
        <v-row class="d-flex align-center">
          <v-col class="itemtitle text-black" cols="4">{{ item.title }}</v-col>
          <v-col class="text-white text-body-1 wrap-text">
            <div v-html="item.text.replace(/<br>/g, '<br />')"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <subtitle :TitleName="'初回限定特典'" />
    <v-row class="listitem flex-column justify-center w-75"
      ><v-col
        ><p class="text-h6">
          飯島多紀哉氏書きおろしショートーストーリー小冊子<br />「いざなわれる者たち」
        </p></v-col
      >
      <v-col class="image-container">
        <img src="@/assets/shokai.png" class="responsive-image" />
      </v-col>
      <v-col
        ><p class="text-Body1">
          「歴史部がなくなるって本当なのか⁉」<br />
          ある春の日、久留米たち歴史部は廃部の危機にさらされていた。<br />
          <br />
          これは、歴史部部長の久留米が、自らの青春と歴史部のプライドをかけた大冒険に赴く少し前に起きた、<br />
          少し不思議な運命の物語である。<br /></p
      ></v-col>
    </v-row>
    <campaign />
  </v-sheet>
</template>
<script>
  import campaign from "./TenpoTokuten.vue";
  import subtitle from "./SubTitle.vue";
  export default {
    components: {
      campaign,
      subtitle,
    },
    data: () => ({
      items: [
        {
          title: "タイトル",
          text: "アパシー　男子校であった怖い話",
        },
        {
          title: "ハード",
          text: "Nintendo Switch",
        },
        {
          title: "ジャンル",
          text: "アドベンチャー",
        },
        {
          title: "CERO",
          text: "C",
        },
        {
          title: "発売日",
          text: "2024/12/19",
        },
        {
          title: "価格",
          text: "7,678円（税抜価格6,980円）",
        },
      ],
    }),
  };
</script>
<style scoped>
  .listitem {
    text-align: center;
    margin: 0 auto;
    padding: 30px;
  }
  .itemtitle {
    background: rgb(var(--v-theme-primary));
    font-weight: bold;
    margin: 1em;
    padding: 0.5em 1em;
    line-height: 2em;
  }
  .wrap-text {
    white-space: normal;
    line-height: 1.2em;
  }
  .image-container {
    display: flex;
    justify-content: center; /* 画像を中央揃え */
    align-items: center; /* 必要なら縦方向も中央揃え */
  }

  .responsive-image {
    max-width: 100%; /* 親要素の幅を超えない */
    height: auto; /* アスペクト比を維持 */
    display: block; /* ブロック要素として扱う */
  }
</style>
